import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Breadcrumb from './components/Breadcrumb';
import HomePage from './components/HomePage';
import About from './components/About';
import Contact from './components/Contact';
import Services from './components/Services';
import Solutions from './components/Solutions';
import SupportWidget from './components/SupportWidget';
import PlaceholderPage from './components/PlaceholderPage';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <Breadcrumb />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/hizmetler" element={<Services />} />
            <Route path="/hizmetler/:slug" element={<Services />} />
            <Route path="/cozumler" element={<Solutions />} />
            <Route path="/cozumler/:slug" element={<Solutions />} />
            {/* Kurumsal */}
            <Route path="/neden-emur" element={<PlaceholderPage />} />
            <Route path="/bilgi-guvenligi" element={<PlaceholderPage />} />
            <Route path="/is-ortaklarimiz" element={<PlaceholderPage />} />
            <Route path="/referanslarimiz" element={<PlaceholderPage />} />
            <Route path="/basari-hikayeleri" element={<PlaceholderPage />} />
            <Route path="/insan-kaynaklari" element={<PlaceholderPage />} />
            <Route path="/basinda-biz" element={<PlaceholderPage />} />
            {/* Auth & Destek */}
            <Route path="/destek" element={<PlaceholderPage />} />
            <Route path="/giris" element={<PlaceholderPage />} />
            <Route path="/kayit" element={<PlaceholderPage />} />
            {/* Legal */}
            <Route path="/gizlilik" element={<PlaceholderPage />} />
            <Route path="/hizmet-sozlesmesi" element={<PlaceholderPage />} />
            <Route path="/kvk-aydinlatma" element={<PlaceholderPage />} />
            {/* 404 */}
            <Route path="*" element={<PlaceholderPage />} />
          </Routes>
        </main>
        <Footer />
        <SupportWidget />
      </div>
    </Router>
  );
}

export default App;
